export default __webpack_public_path__ + "static/media/caesars.1cffb8a7.png";